import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import useCustomState from "../../hooks/State";
import { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Call from "../../service/API";
import { ERROR_COLOR, ORANGE_COLOR } from "../../utils/const";
import { useMountAPI } from "../../hooks/APICall";
import { HOST } from "../../utils/const";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const EditTypeModal = (props) => {
  const handleClose = () => {
    props.open.handleChange(false);
  };

  const counterTypeCategories = useCustomState([]);
  const isLoading = useCustomState(true);

  const counterTypeName = useCustomState("");
  const counterTypeCategory = useCustomState({ title: "", id: -1 });
  const counterTypeDescription = useCustomState("");
  const selectedFile = useCustomState("");
  const categoryImages = useCustomState([]);

  const counterTypeNameError = useCustomState({ error: false, text: "" });
  const counterTypeCategoryError = useCustomState({ error: false, text: "" });

  const counterTypeNameChanged = (e) => {
    counterTypeName.handleChange(e.target.value);
  };

  const counterTypeCategoryChanged = (e, newValue) => {
    counterTypeCategory.handleChange(newValue);
  };

  const counterTypeDescriptionChanged = (e) => {
    counterTypeDescription.handleChange(e.target.value);
  };

  const categoryImagesChanged = (e) => {
    categoryImages.handleChange(e.target.files);
    selectedFile.handleChange(e.target.value);
  };

  const categoryUtils = {
    page: 1,
    count: 1000,
    categoryName: "",
    categoryDate: "",
    isLoading: isLoading,
    categoriesInfo: counterTypeCategories,
  };

  useMountAPI(fetchCategories, categoryUtils);

  useEffect(() => {
    if (!isLoading.value) {
      counterTypeName.handleChange(props.counterType.water_meter_type_name);
      counterTypeCategory.handleChange({
        title: props.counterType.water_meter_tag.water_meter_tag_name,
        id: props.counterType.water_meter_tag.water_meter_tag_id,
      });
      const description = props.counterType.water_meter_type_other_information
        .description
        ? props.counterType.water_meter_type_other_information.description
        : "";
      counterTypeDescription.handleChange(description);
    }
  }, [isLoading.value]);

  const editCounterType = (e) => {
    let hasError;
    const name = counterTypeName.value;
    const category = counterTypeCategory.value;
    const description = counterTypeDescription.value;
    const files = categoryImages.value;

    if (name.length == 0) {
      counterTypeNameError.handleChange({
        error: true,
        text: "واردکردن نوع کنتور الزامی است.",
      });
      hasError = true;
    }
    if (category.title.length == 0 || category.id == -1) {
      counterTypeCategoryError.handleChange({
        error: true,
        text: "انتخاب دسته مناسب برای نوع کنتور الزامی است.",
      });
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const json = {
      water_meter_type_id: props.counterType.water_meter_type_id,
      water_meter_type_new_name: name,
      water_meter_tag_id: category.id,
      water_meter_type_other_information: {
        description: description,
      },
    };

    const data = new FormData();
    data.append("data", JSON.stringify(json));
    if (files.length > 0) {
      data.append("file", files[0]);
    }

    Call("POST", "WaterMeterTypes/admin/edit", data)
      .then((response) => {
        if (response.data.code == 200) {
          selectedFile.handleChange("");
          categoryImages.handleChange([]);
          handleClose();
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
      });
  };

  const marginStyle = {
    marginBottom: "16px",
  };

  if (!isLoading.value) {
    const modalMaxHeight = window.innerHeight - 160;
    const images = props.counterType.water_meter_type_files;
    let typeImage =
      images.length > 0 ? HOST + images[images.length - 1].fileurl : "";
    if (typeImage.length > 0) {
      typeImage = (
        <img
          style={{ borderRadius: "50%" }}
          width="120px"
          height="120px"
          src={typeImage}
        />
      );
    } else {
      typeImage = (
        <Typography style={{ fontSize: "14px" }}>تصویری وجود ندارد.</Typography>
      );
    }
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open.value}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open.value}>
          <Box
            sx={style}
            style={{
              borderRadius: "8px",
              maxHeight: modalMaxHeight + "px",
              overflow: "scroll",
            }}
          >
            <Typography id="transition-modal-title" variant="h6" component="h2">
              ویرایش نوع کنتور
            </Typography>
            <Grid
              style={{ marginTop: "24px" }}
              container
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  onChange={counterTypeNameChanged}
                  value={counterTypeName.value}
                  error={counterTypeNameError.value.error}
                  helperText={counterTypeNameError.value.text}
                  label="نوع کنتور"
                  variant="standard"
                  fullWidth
                />
              </Grid>

              <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
                <Autocomplete
                  onChange={counterTypeCategoryChanged}
                  value={counterTypeCategory.value}
                  options={counterTypeCategories.value}
                  getOptionLabel={(option) => option.title}
                  // disableCloseOnSelect
                  renderInput={(params) => (
                    <TextField
                      error={counterTypeCategoryError.value.error}
                      helperText={counterTypeCategoryError.value.text}
                      {...params}
                      label="دسته"
                      variant="standard"
                    />
                  )}
                />
              </Grid>
              <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  onChange={counterTypeDescriptionChanged}
                  value={counterTypeDescription.value}
                  multiline
                  rows={8}
                  maxRows={12}
                  label="توضیحات نوع کنتور"
                  variant="filled"
                  fullWidth
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  paddingRight: "5%",
                  paddingLeft: "5%",
                  marginTop: "16px",
                  marginBottom: "16px",
                }}
              >
                <Typography>انتخاب تصویر</Typography>
                <input
                  style={{
                    border: "1px solid #333",
                    padding: "6px",
                    borderRadius: "4px",
                  }}
                  onChange={categoryImagesChanged}
                  value={selectedFile.value}
                  type="file"
                  accept=".jpg, .png, .svg, .PNG, .JPG, .JPEG, .jpeg"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  paddingRight: "5%",
                  paddingLeft: "5%",
                  marginTop: "16px",
                  marginBottom: "16px",
                }}
              >
                <Typography style={{ fontWeight: "bold" }}>
                  تصویر کنونی
                </Typography>
                {typeImage}
              </Grid>
              <Grid
                style={{ marginTop: "48px" }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Button
                  onClick={editCounterType}
                  style={{ color: "#fff", backgroundColor: ORANGE_COLOR }}
                  variant="contained"
                >
                  ویرایش
                </Button>
                <Button
                  onClick={handleClose}
                  style={{
                    color: "#fff",
                    marginRight: "4px",
                    backgroundColor: ERROR_COLOR,
                  }}
                  variant="contained"
                >
                  انصراف
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    );
  } else {
    return null;
  }
};

export default EditTypeModal;

const processCategories = (tags) => {
  const results = [];
  let data;
  tags.map((tag) => {
    data = {
      id: tag.water_meter_tag_id,
      title: tag.water_meter_tag_name,
    };
    results.push(data);
  });
  return results;
};

const fetchCategories = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const categoryName = utils.categoryName;
  const categoryDate = utils.categoryDate;
  const isLoading = utils.isLoading;
  const categoriesInfo = utils.categoriesInfo;

  const data = {
    page: page,
    count: count,
    water_meter_tag_name: categoryName,
    water_meter_type_create_date: categoryDate,
  };

  Call("POST", "WaterMeterTags/admin/getAll", data)
    .then((response) => {
      if (response.data.code == 200) {
        categoriesInfo.handleChange(processCategories(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
